import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cp-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectorComponent {
  @Input() selected: string;

  @Input() options: string[];

  @Output() languageChange = new EventEmitter<string>();

  isExpanded = false;

  open() {
    this.isExpanded = true;
  }

  select(option: string) {
    this.languageChange.emit(option);
    this.isExpanded = false;
  }

  getDisplayedLanguage(code: string) {
    return code;
  }
}
